import { render, staticRenderFns } from "./ExFoldCell.vue?vue&type=template&id=5b974f45&scoped=true"
import script from "./ExFoldCell.vue?vue&type=script&lang=js"
export * from "./ExFoldCell.vue?vue&type=script&lang=js"
import style0 from "./ExFoldCell.vue?vue&type=style&index=0&id=5b974f45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b974f45",
  null
  
)

export default component.exports